import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { filter, isEmpty, isEqual } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: null,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: "btn btn-sm"
    },
    inheritFontSize: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterBy: {
      type: Object,
      required: false,
      default: null
    },
    valueOnly: {
      type: Boolean,
      default: false
    },
    triggers: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value,
      textColor: "#000000"
    };
  },
  computed: {
    customOptionText() {
      return this.localValue.value ? this.$tc("global.messages.qtyDays", this.localValue.value, {
        qty: this.localValue.value
      }) : "";
    },
    currentText() {
      return isEmpty(this.localValue) ? this.placeholder || this.$t("automations.selectItems") : this.localValue.name || this.customOptionText;
    },
    dropdownContainerClass() {
      return [this.dropdownValueKey, {
        clickable: !this.readOnly
      }, {
        "fs-inherited": this.inheritFontSize
      }, {
        disabled: this.disabled
      }, this.buttonClass];
    },
    dropdownValueKey() {
      return this.localValue && this.localValue.key || "";
    },
    filteredItems() {
      if (!this.filterBy || !this.filterBy.value) return this.items;
      const {
        path,
        value
      } = this.filterBy;
      return filter(this.items, [path, value]);
    },
    itemsToRender() {
      const items = this.filteredItems;
      if (isEmpty(this.value)) return items;
      return _filterInstanceProperty(items).call(items, item => !isEqual(item, this.value));
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    },
    localValue() {
      this.$emit("input", this.localValue);
      if (!isEmpty(this.localValue)) {
        this.textColor = String(_Object$values(this.localValue.style)[0]);
      }
    },
    //If filter changes, we might be selecting a filtered value
    filterBy(newVal, oldVal) {
      if (newVal.value != oldVal.value) {
        this.localValue = null;
      }
    }
  },
  methods: {
    select(item) {
      this.localValue = item;
    }
  }
});